import { fetchCrownpeakUrlDetails } from "../util/share";
import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { getPageSettings } from "../util/pageSettings";
import { EventTeaserSlider } from "../../global";
const isMigrateEventFTE:boolean = false;

export class EventService {
    constructor(eventDetails: any, errorResponse: any) {
        const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;
        if (pageType && pageType.toLocaleLowerCase() == 'opus 2 event details page') {
            this.init(eventDetails, errorResponse);
        }
    }

static async create() {
    try {
        const dbaName = localStorage.getItem('dbaName');
        let url = await EventService.buildEventUrl(dbaName);
        let newEventService;
        const eventDetails = await getCachedAPIResponse(url, apiCaching.eventDetails);

        if ((Array.isArray(eventDetails?.data) && eventDetails?.data?.length === 0) ||
            (Array.isArray(eventDetails?.data?.events) && eventDetails?.data?.events?.length === 0)) {
            newEventService = new EventService(null, null);
        }
        newEventService = new EventService(eventDetails, null);
        if (isMigrateEventFTE){
            newEventService.migrateEventFTE();
        }
        return newEventService;
    } catch (error: any) {
        if (error.response?.status !== 404) {
            return new EventService(null, error);
        }
        return new EventService(null, null); // For 404, treat as no events
    }
}
private static async buildEventUrl(dbaName: string | null): Promise<string> {
    const origin = window.location.origin;
    if (!dbaName) return `${origin}/eventslandingmodalpopup/none`;

    const brandData = localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null;
    const { include_statename } = brandData ?? {};
    let weblocationInfo = (window as any)?.crownpeakWeblocationsByIdDetail;

    if (!weblocationInfo && include_statename) {
       //here we just check for URL construction. Actual fetchCrownpeakUrlDetails is awaited in create()
        await fetchCrownpeakUrlDetails();
        weblocationInfo = window?.crownpeakWeblocationsByIdDetail;
    }

    if (include_statename && weblocationInfo?.stateName) {
        return `${origin}/eventslandingmodalpopup/${dbaName}/${weblocationInfo.stateName}/`;
    }

    return `${origin}/eventslandingmodalpopup/${dbaName}`;
}

    private init(eventDetails: any, errorResponse: any) {
        if(eventDetails) {
            const rawData = eventDetails?.events ?? [];
            const data = Array.isArray(rawData) ? rawData : [];
            const pathname = window.location.pathname.replace(/\/$/, '');
            //to skip null or undefined elements
            const index = data.findIndex((x: any) => x?.href && x?.href?.replace(/\/$/, '') === pathname);
            this.updatePaginationButtons(index, data);
        }

        if(errorResponse) {
            console.error("Error fetching event details:", errorResponse);
            this.disablesPagination();
        }
    }


    disablesPagination() {
        const elements = document.querySelectorAll('.events-section .pagination-link');
        elements.forEach((element: Element, index: number, nodeList: NodeListOf<Element>) => {
            (element as HTMLElement).style.opacity = '0.3';
            (element as HTMLElement).style.pointerEvents = 'none';
        });
    }
    

    updatePaginationButtons(index: number, data: any[]) {

        const btns: any = document.querySelectorAll('.events-section .pagination-link');
        const prevBtn = btns[0];
        const nextBtn = btns[1];

        if (index !== -1) {
            if (index > 0 && data[index - 1]?.href) {
                prevBtn.href = data[index - 1].href;
            } else {
                prevBtn.disabled = true;
                prevBtn.style.opacity = '0.3';
            }

            if ((index < data?.length - 1) && data[index + 1]?.href) {
                nextBtn.href = data[index + 1].href;
            } else {
                nextBtn.disabled = true;
                nextBtn.style.opacity = '0.3';
            }
        }
    }

    async migrateEventFTE(): Promise<void> {
        try {
            const dbaName = localStorage.getItem('dbaName');
            if (!dbaName) {
                console.warn("DBA name not found in localStorage.");
                return;
            }

            if(window.location.href.includes(dbaName)) return;
            const eventSection = document.querySelector(".events-section");
            const eventTeaser = document.querySelector(".upcoming-events-section .card-wrapper");
            if(eventTeaser || eventSection){
                const isEventTeaserComponent = getPageSettings("EventTeaserComponent") ?? false;
                const isEventTeaserComponentView = getPageSettings("EventTeaserComponentView");
                const stateName = await this.safeGetStateName();
                const { APIUrl, eventDom } = this.buildApiUrlAndDom(isEventTeaserComponent, isEventTeaserComponentView, dbaName, stateName);
                await this.handleTeaserComponent(APIUrl, eventDom, isEventTeaserComponent);
            }
        } catch (outerError) {
            console.error("Unexpected error in migrateEventFTE:", outerError);
        }
    }

    private async safeGetStateName(): Promise<string> {
        try {
            return await this.getStateName();
        } catch (err) {
            console.error("Error getting state name:", err);
            return '';
        }
    }

    private buildApiUrlAndDom(
        isEventTeaserComponent: any,
        isEventTeaserComponentView: any,
        dbaName: string,
        stateName: string
    ): { APIUrl: string; eventDom: Element | null } {
        let APIUrl = `${window.location.origin}`;
        let eventDom: Element | null = null;
        const eventSection = document.querySelector(".events-section");
        
        if (isEventTeaserComponent && isEventTeaserComponentView) {
            APIUrl += `/eventsteaserdata/${isEventTeaserComponentView}`;
            eventDom = document.querySelector(".upcoming-events-section .card-wrapper");
        } else if(eventSection){
            APIUrl += `/eventslandingpage`;
            eventDom = eventSection;
        }

        if (dbaName) {
            APIUrl += `/${dbaName}`;
        }
        if (stateName) {
            APIUrl += `/${stateName}`;
        }

        return { APIUrl, eventDom };
    }

    private async handleTeaserComponent(APIUrl: string, eventDom: Element | null, isEventTeaserComponent: boolean): Promise<void> {
        try {
            const response = await getCachedAPIResponse(APIUrl);
            if (!response) {
                console.warn("No response received from API:", APIUrl);
                return;
            }
            if (eventDom) {
                eventDom.outerHTML = response;
                if (isEventTeaserComponent && document.querySelector(".card-wrapper.upcoming-events-slider")) {
                    this.initSliderSafe();
                }
            } else {
                console.warn("Event DOM not found for selector: .card-wrapper.upcoming-events-slider");
            }
        } catch (error) {
            console.error("Error fetching event teaser data:", error);
        }
    }

    private initSliderSafe(): void {
        try {
            EventTeaserSlider.getInstance()?.initSlider();
        } catch (sliderErr) {
            console.error("Error initializing EventTeaserSlider:", sliderErr);
        }
    }

    getStateName = async (): Promise<string> => {
        const brandData = localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null;
        const { include_statename } = brandData ?? {};
        let weblocationInfo = (window as any)?.crownpeakWeblocationsByIdDetail;

        if (!weblocationInfo && include_statename) {
            await fetchCrownpeakUrlDetails();
            weblocationInfo = window?.crownpeakWeblocationsByIdDetail;
        }
        return (include_statename && weblocationInfo?.stateName) ? `${weblocationInfo.stateName}` : '';
    };

}
